<app-page-header [title]="title.getTitle()"></app-page-header>
<section class="page-area">
  <div class="padded-content top-bottom-padding">
    <app-content-header title="You do not have access to this page"></app-content-header>
    <a class="btn btn-primary" href="/">Return to the dashboard</a>
  </div>
</section>
